import _ from "lodash";

export const getPermanentNotifications = (state) =>
  state.permanentNotifications;

export const getPermanentNotificationById = (state, id) => {
  const notifications = getPermanentNotifications(state);
  return _.find(notifications, ["id", id]);
};
